var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navbar'),_c('v-main',[_c('router-view')],1),_c('v-footer',{attrs:{"app":""}},[_c('v-flex',{attrs:{"text-xs-center":""}},[_c('div',{staticClass:"grey--text"},[_vm._v("© 2019 - "),_c('a',{attrs:{"href":"https://atelierueda.uedasoft.com"}},[_vm._v("Atelier UEDA")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }